export default __webpack_public_path__ + "static/media/White0001.a793afd8.png";